// extracted by mini-css-extract-plugin
module.exports = {"logoutSection":"ob_MwMk0K","logoutSection__email":"ob_xdelmw","logoutSection__btn":"ob_CVikl2"};